import { useSuspenseQuery } from '@tanstack/react-query';

import { companyClient } from '../client/companyClient';
import { cacheKeys } from '../config';


type Options = {
  retry?: boolean;
};

const defaultOptions: Partial<Options> = {
  retry: false,
};

export const useCompanies = (params: Companies.GetListParams = {}, options: Partial<Options> = defaultOptions) => {
  const { data: { data } = {}, status, error } = useSuspenseQuery({
    queryKey: [cacheKeys.getCompanies, params],
    queryFn: () => companyClient.getCompanies(params),
    retry: options.retry,
  });

  return {
    status,
    error,
    count: data?.count,
    companies: data?.results || [],
  };
};
